import { render, staticRenderFns } from "./infoShipmentCompanyForm.vue?vue&type=template&id=5c14bf06"
import script from "./infoShipmentCompanyForm.vue?vue&type=script&lang=js"
export * from "./infoShipmentCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports